import { getLocaleSettings, readCookieValue } from './utils'
import { version } from '../../../package.json'

import parser from 'ua-parser-js'

const NOT_AVAILABLE = 'NA'

export interface DeviceInfo {
  deviceId: string
  os: string
  osVersion: string
  browser: string
  version: string
  userAgent: string
  screenWidth: string
  screenHeight: string
  screenSize: string
  networkType: string
  platform: string
  model: string
  manufacturer: string
  acquired_country: string
}

type WindowLike = {
  screen: Pick<Window['screen'], 'width' | 'height'>
  navigator: Pick<Window['navigator'], 'userAgent' | 'appVersion' | 'appName'>
  localeSettings: {
    userCountry: string
    region: string
    isWorldwide: number | string
  }
}
export const getDeviceInfo = (windowObj: WindowLike): DeviceInfo => {
  const { screen, navigator } = windowObj

  const localeSettings = getLocaleSettings()
  const { userCountry, isWorldwide, region } = localeSettings
  const acquiredCountry = isWorldwide ? userCountry : region
  let screenSize = ''
  let screenWidth = NOT_AVAILABLE
  let screenHeight = NOT_AVAILABLE
  if (screen && screen.width) {
    screenWidth = screen.width ? `${screen.width}` : NOT_AVAILABLE
    screenHeight = screen.height ? `${screen.height}` : NOT_AVAILABLE
    screenSize += `${screenWidth}*${screenHeight}`
  }
  const deviceId =
    readCookieValue(document.cookie, 'dvid') || readCookieValue(document.cookie, '__gi_vid') || NOT_AVAILABLE

  let networkType: string = NOT_AVAILABLE
  if (
    'connection' in windowObj.navigator &&
    typeof windowObj.navigator.connection === 'object' &&
    windowObj.navigator.connection
  ) {
    if (
      'effectiveType' in windowObj.navigator.connection &&
      typeof windowObj.navigator.connection.effectiveType === 'string'
    ) {
      networkType = windowObj.navigator.connection.effectiveType
    }
  }
  const { browser, os, device } = parser(navigator.userAgent)
  let platform: string
  switch (device.type?.toLowerCase()) {
    case 'mobile':
    case 'tablet':
      platform = 'pwa'
      break
    default:
      platform = 'desktop'
      break
  }
  return {
    deviceId,
    os: os.name?.toLowerCase() || NOT_AVAILABLE,
    osVersion: os.version || NOT_AVAILABLE,
    browser: browser.name || NOT_AVAILABLE,
    version: version || NOT_AVAILABLE,
    userAgent: navigator.userAgent,
    screenSize,
    screenWidth,
    screenHeight,
    networkType: networkType,
    platform,
    model: device.model || NOT_AVAILABLE,
    manufacturer: device.vendor || NOT_AVAILABLE,
    acquired_country: acquiredCountry,
  }
}
